import { FunctionComponent } from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

// header and footer are fixed position by default, then change on breakpoints
// at sm, it becomes sticky, so we remove the extra padding that accounts for fixed
// will need to potentially account for in native app as well.
// this is adjusted for a taller header than what exists on consumer, so the base is 68 :)

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootStandard: {
      paddingBottom: theme.typography.pxToRem(89), // bottom nav + some padding for the page itself = to theme.spacing(3)
      paddingTop: theme.typography.pxToRem(theme.spacing(3)), // only padding for the page itself, equal to theme.spacing(3)
      [theme.breakpoints.up('sm')]: {
        paddingBottom: theme.spacing(4),
        paddingTop: theme.spacing(4),
      },
    },
    rootSimple: {
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4),
    },
  })
);

/**
 * standard = fixed/sticky header, mobile bottom nav that's fixed
 * simple = custom header, no mobile bottom nav
 */
type PageType = 'standard' | 'simple';

export interface PageProps {
  /**
   * PageType defaults to standard, used to specify content padding for heaaders and footers
   * see PageType for explanations of possible values
   */
  type?: PageType;
  /**
   * provide an additional className for page container specific requirements, such as somehting that has a negative margin
   */
  className?: string;
}

/**
 *  Page is a root level content container that provides padding to offset the header and bottom nav
 */
export const Page: FunctionComponent<PageProps> = ({ type = 'standard', children, className }) => {
  const classes = useStyles();
  return (
    <div
      className={clsx(className, {
        [classes.rootStandard]: type === 'standard',
        [classes.rootSimple]: type === 'simple',
      })}
    >
      {children}
    </div>
  );
};
